import React from 'react';
import { Chip } from '@mui/material';

/**
 * Status pill. Accepts a status string + a color map (status → MUI
 * palette token). Centralizes the "what color is `paid`?" decision so
 * we don't repeat it on every page.
 *
 *   <StatusChip status="paid" colors={{ paid: 'primary', cancelled: 'error' }} />
 */
export default function StatusChip({ status, colors = {}, size = 'small', label, sx }) {
  return (
    <Chip
      size={size}
      label={label != null ? label : status}
      color={colors[status] || 'default'}
      sx={sx}
    />
  );
}
